import { Colors } from "@/enums/Colors";
import { Autocomplete, Paper, styled } from "@mui/material";

export const StyledAutocompletePaper = styled(Paper)(() => ({
  borderRadius: "8px",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
}));

export const StyledAutoComplete = styled(Autocomplete)(() => ({
  "& .MuiOutlinedInput-root": {
    height: "2.750rem",
    "& fieldset": {
      borderRadius: "0.500rem",
      borderColor: Colors.STROKE_DARK_GRAY,
      borderWidth: "1px",
      transition: "ease 0.3s all",
    },
    "&:hover fieldset": { borderWidth: "1px", borderColor: Colors.BUTTON_PURPLE },
    "&.Mui-focused fieldset": { borderWidth: "1px", borderColor: Colors.BUTTON_PURPLE },
  },
  "& .MuiAutocomplete-inputRoot": {
    padding: "8px 14px",
    paddingRight: "39px !important", // Ensure space for dropdown arrow
    display: "flex",
    alignItems: "center",
  },
  "& .MuiAutocomplete-input": {
    padding: "0 !important", // Remove default input padding since we handle it in inputRoot
    lineHeight: "1.2",
  },
}));
